import axios from 'axios'

import { IsDev } from '../helpers/build'
import { SEARCH_ENDPOINT} from '../helpers/request'
import {asyncTimeout} from '../helpers/utils'
import {cleanUrlParam} from '../helpers/urlHelpers'

const mockData = () => require('../mocks/hotels').default
export default async function (parameters) {
  if (IsDev) {
    console.info(`%c GET /hotels from mock data`, 'color: #67a9ad; font-weight: bold;')
    await asyncTimeout(2)
    return {data: mockData()}
  }
  const params = cleanUrlParam(parameters)
  const url = SEARCH_ENDPOINT + params;
  return await axios.get(url)
}
